<main>
    <!-- <app-header></app-header> -->
	<router-outlet></router-outlet>
	<app-loading-global *ngIf="loading?.loading"></app-loading-global>
    <app-loading-progress *ngIf="loading?.loadingProgress"></app-loading-progress>
</main>
